import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DialogBoxComponent } from "../dialog-box/dialog-box.component";

@Component({
  selector: "app-pandemi-islemleri",
  templateUrl: "./pandemi-islemleri.component.html",
  styleUrls: ["./pandemi-islemleri.component.css"],
})
export class PandemiIslemleriComponent {
  isSubmitted = false;
  durum1 = false;
  durum2 = false;
  durum3 = false;
  msj1 =
    "Bu Belirtileri taşıyan hastalar risk grubu olarak değerlendirilmektedir. DİŞ Hekimliği işlemleri için daha sağlıklı günlerde görüşmek dileğiyle. COVİD-19 değerlendirmesi için en kısa sürede Sağlık Bakanlığı 184 nolu hattı arayınız!";
  msj2 =
    "Bu Belirtileri taşıyan hastalar risk grubu olarak değerlendirilmektedir. DİŞ Hekimliği işlemleri için daha sağlıklı günlerde görüşmek dileğiyle. COVİD-19 değerlendirmesi için en kısa sürede Sağlık Bakanlığı 184 nolu hattı arayınız.";
  msj3 =
    "Rutin kontroller, yer tutucu kontrolleri, dişin çapraşıklığı ve çıkmaması gibi ortodontik problemler, düşme zamanı gelmiş sallanan süt dişleri, ağrı kesici kullanımı ile hafifleyen ve dişin fırçalanması ile geçen yemek birikmesine bağlı rahatsızlıklar nedeniyle yapmak istediğiniz başvurular Sağlık Bakanlığının önerisi gereğince pandemi sonrasına kadar ertelenmelidir. Sağlıklı ve Mutlu Günler Dileriz. ";

  constructor(
    public gs: FormBuilder,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit() {}

  /*########### Form ###########*/
  registrationForm = this.gs.group({
    soru1: ["", [Validators.required]],
    soru2: ["", [Validators.required]],
    soru3: ["", [Validators.required]],
    soru4: ["", [Validators.required]],
  });

  // Submit Registration Form
  onSubmit() {
    if (this.registrationForm.get("soru1").value == "evet") {
      this.openDialog("Lüten Dikkat!", this.msj1, "Tamam", null);
    }
    if (this.registrationForm.get("soru1").value == "hayir") this.durum1 = true;

    if (this.registrationForm.get("soru2").value == "evet") {
      this.openDialog("Lüten Dikkat!", this.msj2, "Tamam", null);
    }
    if (this.registrationForm.get("soru2").value == "hayir") this.durum2 = true;

    if (this.registrationForm.get("soru3").value == "evet") {
      return this.router.navigateByUrl("kimlik-bilgisi");
    }
    if (this.registrationForm.get("soru3").value == "hayir") this.durum3 = true;

    if (this.registrationForm.get("soru4").value == "evet")
      return this.router.navigateByUrl("kimlik-bilgisi");

    if (this.registrationForm.get("soru4").value == "hayir") {
      this.openDialog("Lüten Dikkat!", this.msj3, "Tamam", null);
    }
  }

  openDialog(
    _baslik: string,
    _mesaj: string,
    _bntOk: string,
    _btnIptal: string
  ): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "40%";

    let dialogRef = this.dialog.open(DialogBoxComponent, {
      disableClose: true,
      autoFocus: true,
      width: "45%",

      data: {
        baslik: _baslik,
        mesaj: _mesaj,
        bntOk: _bntOk,
        btnIptal: _btnIptal,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
        return this.router.navigateByUrl("randevu-islemleri");
    });

    const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(
      (result) => {
        ///  dialogSubmitSubscription.unsubscribe();
      }
    );
  }

}
